import { Typography } from "@mui/material";
import './styles.css';
import { sxTypographyAdvice } from "./sxProps";
import parse, { domToReact } from 'html-react-parser';
import { Link } from "react-router-dom";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

const SimulationAdvice: React.FC<{ textoAviso: string }> = ({ textoAviso }) => {

  const accessibility = useAccessibility();

  const replaceLink = (node: any) => {
    if (node.name === 'a') {
      return <Link to="/financeiro/demonstrativoFatura">{domToReact(node.children)}</Link>;
    }
  };

  return (
    <div className='simulation-advice-container' style={{ ...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility, }}>
      <div className='advice-text'>
        <Typography style={accessibility.textStyleAccessibility} sx={sxTypographyAdvice}>
          {parse(textoAviso, { replace: replaceLink })}
        </Typography>
      </div>
    </div>
  )
}

export default SimulationAdvice;